var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9078 3.11639H12.675C13.0688 3.11639 13.388 3.43559 13.388 3.82935C13.388 4.22311 13.0688 4.54231 12.675 4.54231H11.4493L8.95392 14.5238H10.1797C10.5734 14.5238 10.8926 14.843 10.8926 15.2368C10.8926 15.6305 10.5734 15.9497 10.1797 15.9497H8.05651C8.04641 15.9499 8.03627 15.9499 8.02611 15.9497H6.25837C5.86461 15.9497 5.54541 15.6305 5.54541 15.2368C5.54541 14.843 5.86461 14.5238 6.25837 14.5238H7.48411L9.97948 4.54231H8.75374C8.35998 4.54231 8.04078 4.22311 8.04078 3.82935C8.04078 3.43559 8.35998 3.11639 8.75374 3.11639H10.8764C10.8868 3.11615 10.8973 3.11615 10.9078 3.11639Z",
    fill: "#33383F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicIcon);
export default __webpack_public_path__ + "static/media/italic_icon.166ece68d095fecf699ff0bf5bc86446.svg";
export { ForwardRef as ReactComponent };